import { PAYMENT_ORDER_STATUS_ENDPOINT } from '../endpoints';
import { authorizedRequest } from '../wrapper';
import { PAYMENT_SESSION_ID } from 'constants/const';

export const paymentOrderStatusRequest = () => authorizedRequest(PAYMENT_ORDER_STATUS_ENDPOINT, { params: {
  session_id: localStorage.getItem(PAYMENT_SESSION_ID),
} });
